/**
 * The icons catalog name.
 */
export enum IconsCatalog {
  /**
   * Entity Services
   */
  EntityServices = 'entity-services',
}
